import {
  ChangeDetectionStrategy,
  Component,
  Input,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DuoSelector } from 'www-cms';
import { DirectusDirective } from 'directus';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { CommonModule as SSCommonModule } from 'common';
import { DuoSelectorToggleComponent } from 'ui-elements/duo-selector-toggle';
import { TextBlockComponent } from '../text-block/text-block.component';

@Component({
  selector: 'ss-www-duo-selector',
  imports: [
    SSCommonModule,
    DuoSelectorToggleComponent,
    TextBlockComponent,
    DirectusDirective,
  ],
  templateUrl: './duo-selector.component.html',
  styleUrl: './duo-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DuoSelectorComponent extends BaseBuildingBlockComponent {
  @Input() duoSelectorData!: DuoSelector;
  selectedOption = signal<string>('left');

  get duoSelectorToggleData() {
    return {
      leftButton: {
        text: 'ADULT AUDITIONS',
        value: 'left',
      },
      rightButton: {
        text: 'MINOR AUDITIONS',
        value: 'right',
      },
    };
  }

  onToggleChange(value: string): void {
    this.selectedOption.set(value);
  }

  override getBgClass(): LastItemBgClass {
    return 'bg-white';
  }
}
